import ECheckPaymentDetailDesktop from './ECheckPaymentDetailDesktop';
import { connect } from 'react-redux';
import { paymentsActions } from 'src/store/modules/payments';

const mapDispatchToProps = (dispatch: any) => ({
  updatePayment: (databaseId: number, params: any) => {
    dispatch(paymentsActions.updatePayment(databaseId, params));
  }
});

export default connect(
  undefined,
  mapDispatchToProps
)(ECheckPaymentDetailDesktop);
